var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"mod_msg"},[_c('h3',[_vm._v("系统报错啦")]),_c('p',[_vm._v("请稍后再重新再试吧~")])])])}]

export { render, staticRenderFns }